import { render, staticRenderFns } from "./BtnDevolver.vue?vue&type=template&id=2050ba64"
import script from "./BtnDevolver.vue?vue&type=script&lang=js"
export * from "./BtnDevolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports